import { render } from "./CommentsWall.vue?vue&type=template&id=2c68bf0a&scoped=true"
import script from "./CommentsWall.vue?vue&type=script&lang=js"
export * from "./CommentsWall.vue?vue&type=script&lang=js"

import "./CommentsWall.vue?vue&type=style&index=0&id=2c68bf0a&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c68bf0a"]])

export default __exports__